import { useQuery } from '@apollo/client';
import { getMaterialMacrosTemplate } from 'apollo/templates/material-macro';
import { MaterialMacro } from 'models/material-macro';
import { useDenthubErrorBoundary } from 'components/shared/denthub-error-boundary/denthub-error-boundary-context';

type MaterialMacrosQueryResult = {
    materialMacros: MaterialMacro[];
};

// All material macros of the current lab (the backend scopes the query to the caller's
// organization). Several callers on one page share the Apollo cache entry, so a grid and
// the dialog it opens cost a single request between them.
export const useMaterialMacros = (skip = false) => {
    const { showBoundary } = useDenthubErrorBoundary();
    const { data, loading } = useQuery<MaterialMacrosQueryResult>(getMaterialMacrosTemplate, {
        skip,
        onError(error) {
            showBoundary(error);
        },
    });
    const materialMacros = data?.materialMacros || [];

    return {
        materialMacros,
        hasMaterialMacros: materialMacros.length > 0,
        isLoading: loading,
    };
};
